module.exports = __webpack_public_path__ + "static/media/fly0128.75c5db4c.webp";